module.exports = __webpack_public_path__ + "img/translationeditor_9.ee58c4fe.jpg";